/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AcceleratedPaydownInvestmentTableRetrieveParams
} from '../../model/acceleratedPaydownInvestmentTableRetrieveParams'
import type {
  AuditDocuments
} from '../../model/auditDocuments'
import type {
  CeleryWorkflowStatusList
} from '../../model/celeryWorkflowStatusList'
import type {
  DocumentReadData
} from '../../model/documentReadData'
import type {
  DocumentReadDataList
} from '../../model/documentReadDataList'
import type {
  FeeChargeEventsWithOutstandingOffsetExpenseAmountsByExpenseTransactionCodes
} from '../../model/feeChargeEventsWithOutstandingOffsetExpenseAmountsByExpenseTransactionCodes'
import type {
  FeeTrueUpEventReadDataList
} from '../../model/feeTrueUpEventReadDataList'
import type {
  FundExpenseAllocationTableAndStats
} from '../../model/fundExpenseAllocationTableAndStats'
import type {
  FundFamilyEventAPIData
} from '../../model/fundFamilyEventAPIData'
import type {
  FundFamilyEventData
} from '../../model/fundFamilyEventData'
import type {
  FundFamilyEventEditDataRequest
} from '../../model/fundFamilyEventEditDataRequest'
import type {
  FundFamilyEventRefreshData
} from '../../model/fundFamilyEventRefreshData'
import type {
  FundFamilySubEventCreateDataRetrieveParams
} from '../../model/fundFamilySubEventCreateDataRetrieveParams'
import type {
  FundFamilySubEventFirstRetrieveParams
} from '../../model/fundFamilySubEventFirstRetrieveParams'
import type {
  FundFamilySubEventListParams
} from '../../model/fundFamilySubEventListParams'
import type {
  FundFamilySubEventReadData
} from '../../model/fundFamilySubEventReadData'
import type {
  FundFamilySubEventReadDataList
} from '../../model/fundFamilySubEventReadDataList'
import type {
  GenericFundFamilySubEventCreateData
} from '../../model/genericFundFamilySubEventCreateData'
import type {
  GenericFundFamilySubEventCreateDataRequest
} from '../../model/genericFundFamilySubEventCreateDataRequest'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  HybridWaterfallRunAdditionalDataRequest
} from '../../model/hybridWaterfallRunAdditionalDataRequest'
import type {
  HybridWaterfallRunUpsertDataRequest
} from '../../model/hybridWaterfallRunUpsertDataRequest'
import type {
  NoticeDocumentCreateDataRequest
} from '../../model/noticeDocumentCreateDataRequest'
import type {
  NoticeDocumentGenerationStatusData
} from '../../model/noticeDocumentGenerationStatusData'
import type {
  NoticeDocumentReadData
} from '../../model/noticeDocumentReadData'
import type {
  NullableFundfmailySubEventData
} from '../../model/nullableFundfmailySubEventData'
import type {
  PaydownTableResponse
} from '../../model/paydownTableResponse'
import type {
  PreferredReturnSummaryData
} from '../../model/preferredReturnSummaryData'
import type {
  RequiredPaydownInvestmentTableRetrieveParams
} from '../../model/requiredPaydownInvestmentTableRetrieveParams'
import type {
  TransactionMapAPIResponse
} from '../../model/transactionMapAPIResponse'
import type {
  TransactionMapRetrieveParams
} from '../../model/transactionMapRetrieveParams'
import type {
  WaterfallAuditExcelWorkbookCreateParams
} from '../../model/waterfallAuditExcelWorkbookCreateParams'
import type {
  WaterfallBreakdownRetrieveParams
} from '../../model/waterfallBreakdownRetrieveParams'
import type {
  WaterfallDistributionData
} from '../../model/waterfallDistributionData'
import type {
  WaterfallInvestorLevelBreakdownTableDataRetrieveParams
} from '../../model/waterfallInvestorLevelBreakdownTableDataRetrieveParams'
import type {
  WaterfallPreferredReturnBreakdownTableDataRetrieveParams
} from '../../model/waterfallPreferredReturnBreakdownTableDataRetrieveParams'
import type {
  WaterfallPreferredReturnSummaryDataRetrieveParams
} from '../../model/waterfallPreferredReturnSummaryDataRetrieveParams'
import type {
  WaterfallRunData
} from '../../model/waterfallRunData'
import type {
  WaterfallRunDataList
} from '../../model/waterfallRunDataList'
import type {
  WaterfallRunListParams
} from '../../model/waterfallRunListParams'
import type {
  WaterfallTiers
} from '../../model/waterfallTiers'
import type {
  WaterfallTiersRetrieveParams
} from '../../model/waterfallTiersRetrieveParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * List the status of a Celery workflow.
 */
export const fundFamilyEventCeleryWorkflowStatusList = (
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CeleryWorkflowStatusList>(
      {url: `/fund-family-event/${fundFamilyEventId}/celery-workflow-status/`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilyEventCeleryWorkflowStatusListQueryKey = (fundFamilyEventId: string,) => {
    return [`/fund-family-event/${fundFamilyEventId}/celery-workflow-status/`] as const;
    }

    
export const getFundFamilyEventCeleryWorkflowStatusListQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>, TError = unknown>(fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyEventCeleryWorkflowStatusListQueryKey(fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>> = ({ signal }) => fundFamilyEventCeleryWorkflowStatusList(fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyEventCeleryWorkflowStatusListQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>>
export type FundFamilyEventCeleryWorkflowStatusListQueryError = unknown

export const useFundFamilyEventCeleryWorkflowStatusList = <TData = Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>, TError = unknown>(
 fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyEventCeleryWorkflowStatusListQueryOptions(fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilyEventCeleryWorkflowStatusListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>, TError = unknown>(fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyEventCeleryWorkflowStatusListQueryKey(fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>> = ({ signal }) => fundFamilyEventCeleryWorkflowStatusList(fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyEventCeleryWorkflowStatusListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>>
export type FundFamilyEventCeleryWorkflowStatusListSuspenseQueryError = unknown

export const useFundFamilyEventCeleryWorkflowStatusListSuspense = <TData = Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>, TError = unknown>(
 fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventCeleryWorkflowStatusList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyEventCeleryWorkflowStatusListSuspenseQueryOptions(fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilyEventCeleryWorkflowStatusListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilyEventCeleryWorkflowStatusListQueryKey(fundFamilyEventId),
              queryFn: () => fundFamilyEventCeleryWorkflowStatusList(fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets a fund family event
 */
export const fundFamilyEventRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilyEventAPIData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilyEventRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}`] as const;
    }

    
export const getFundFamilyEventRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyEventRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyEventRetrieve>>> = ({ signal }) => fundFamilyEventRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyEventRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventRetrieve>>>
export type FundFamilyEventRetrieveQueryError = unknown

export const useFundFamilyEventRetrieve = <TData = Awaited<ReturnType<typeof fundFamilyEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyEventRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilyEventRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyEventRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyEventRetrieve>>> = ({ signal }) => fundFamilyEventRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyEventRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventRetrieve>>>
export type FundFamilyEventRetrieveSuspenseQueryError = unknown

export const useFundFamilyEventRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilyEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyEventRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilyEventRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilyEventRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => fundFamilyEventRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Updates a fund family event
 */
export const fundFamilyEventUpdate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilyEventEditDataRequest: FundFamilyEventEditDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fundFamilyEventEditDataRequest
    },
      options);
    }
  


export const getFundFamilyEventUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventUpdate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventUpdate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventEditDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyEventUpdate>>, {fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventEditDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  fundFamilyEventUpdate(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyEventUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventUpdate>>>
    export type FundFamilyEventUpdateMutationBody = FundFamilyEventEditDataRequest
    export type FundFamilyEventUpdateMutationError = unknown

    export const useFundFamilyEventUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventUpdate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FundFamilyEventEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyEventUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes a fund family event
 */
export const fundFamilyEventDelete = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}`, method: 'DELETE'
    },
      options);
    }
  


export const getFundFamilyEventDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyEventDelete>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  fundFamilyEventDelete(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyEventDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventDelete>>>
    
    export type FundFamilyEventDeleteMutationError = unknown

    export const useFundFamilyEventDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyEventDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets a fund family sub event create data
 */
export const fundFamilySubEventCreateDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventCreateDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericFundFamilySubEventCreateData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/create-data`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFundFamilySubEventCreateDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventCreateDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/create-data`, ...(params ? [params]: [])] as const;
    }

    
export const getFundFamilySubEventCreateDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventCreateDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySubEventCreateDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>> = ({ signal }) => fundFamilySubEventCreateDataRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySubEventCreateDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>>
export type FundFamilySubEventCreateDataRetrieveQueryError = unknown

export const useFundFamilySubEventCreateDataRetrieve = <TData = Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventCreateDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySubEventCreateDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilySubEventCreateDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventCreateDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySubEventCreateDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>> = ({ signal }) => fundFamilySubEventCreateDataRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySubEventCreateDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>>
export type FundFamilySubEventCreateDataRetrieveSuspenseQueryError = unknown

export const useFundFamilySubEventCreateDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventCreateDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventCreateDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySubEventCreateDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilySubEventCreateDataRetrieveLoader = (queryParamsOrFn?: (FundFamilySubEventCreateDataRetrieveParams | ((params: Params) => FundFamilySubEventCreateDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilySubEventCreateDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => fundFamilySubEventCreateDataRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get table representing the breakdown of the management fee true up for a particular posted event
 */
export const feeTrueUpBreakdownForEventTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fee-catch-up`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeTrueUpBreakdownForEventTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fee-catch-up`] as const;
    }

    
export const getFeeTrueUpBreakdownForEventTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeTrueUpBreakdownForEventTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>> = ({ signal }) => feeTrueUpBreakdownForEventTableDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeTrueUpBreakdownForEventTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>>
export type FeeTrueUpBreakdownForEventTableDataRetrieveQueryError = unknown

export const useFeeTrueUpBreakdownForEventTableDataRetrieve = <TData = Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeTrueUpBreakdownForEventTableDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeTrueUpBreakdownForEventTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeTrueUpBreakdownForEventTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>> = ({ signal }) => feeTrueUpBreakdownForEventTableDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeTrueUpBreakdownForEventTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>>
export type FeeTrueUpBreakdownForEventTableDataRetrieveSuspenseQueryError = unknown

export const useFeeTrueUpBreakdownForEventTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeTrueUpBreakdownForEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeTrueUpBreakdownForEventTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeTrueUpBreakdownForEventTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeTrueUpBreakdownForEventTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => feeTrueUpBreakdownForEventTableDataRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get table representing the breakdown of the management fee equalized offsets for a particular event
 */
export const feeOffsetsTrueUpBreakdownTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fee-offsets-true-up`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeOffsetsTrueUpBreakdownTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fee-offsets-true-up`] as const;
    }

    
export const getFeeOffsetsTrueUpBreakdownTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeOffsetsTrueUpBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>> = ({ signal }) => feeOffsetsTrueUpBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeOffsetsTrueUpBreakdownTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>>
export type FeeOffsetsTrueUpBreakdownTableDataRetrieveQueryError = unknown

export const useFeeOffsetsTrueUpBreakdownTableDataRetrieve = <TData = Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeOffsetsTrueUpBreakdownTableDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeOffsetsTrueUpBreakdownTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeOffsetsTrueUpBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>> = ({ signal }) => feeOffsetsTrueUpBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeOffsetsTrueUpBreakdownTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>>
export type FeeOffsetsTrueUpBreakdownTableDataRetrieveSuspenseQueryError = unknown

export const useFeeOffsetsTrueUpBreakdownTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetsTrueUpBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeOffsetsTrueUpBreakdownTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeOffsetsTrueUpBreakdownTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeOffsetsTrueUpBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => feeOffsetsTrueUpBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get table representing the breakdown of the management fee equalized waivers for a particular event
 */
export const feeWaiversTrueUpBreakdownTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fee-waivers-true-up`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeWaiversTrueUpBreakdownTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fee-waivers-true-up`] as const;
    }

    
export const getFeeWaiversTrueUpBreakdownTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeWaiversTrueUpBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>> = ({ signal }) => feeWaiversTrueUpBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeWaiversTrueUpBreakdownTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>>
export type FeeWaiversTrueUpBreakdownTableDataRetrieveQueryError = unknown

export const useFeeWaiversTrueUpBreakdownTableDataRetrieve = <TData = Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeWaiversTrueUpBreakdownTableDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeWaiversTrueUpBreakdownTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeWaiversTrueUpBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>> = ({ signal }) => feeWaiversTrueUpBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeWaiversTrueUpBreakdownTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>>
export type FeeWaiversTrueUpBreakdownTableDataRetrieveSuspenseQueryError = unknown

export const useFeeWaiversTrueUpBreakdownTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeWaiversTrueUpBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeWaiversTrueUpBreakdownTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeWaiversTrueUpBreakdownTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeWaiversTrueUpBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => feeWaiversTrueUpBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * List fee true up events
 */
export const feeTrueUpEventList = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeTrueUpEventReadDataList>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fee_true_up/`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeTrueUpEventListQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fee_true_up/`] as const;
    }

    
export const getFeeTrueUpEventListQueryOptions = <TData = Awaited<ReturnType<typeof feeTrueUpEventList>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeTrueUpEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeTrueUpEventListQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeTrueUpEventList>>> = ({ signal }) => feeTrueUpEventList(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeTrueUpEventList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeTrueUpEventListQueryResult = NonNullable<Awaited<ReturnType<typeof feeTrueUpEventList>>>
export type FeeTrueUpEventListQueryError = unknown

export const useFeeTrueUpEventList = <TData = Awaited<ReturnType<typeof feeTrueUpEventList>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeTrueUpEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeTrueUpEventListQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeTrueUpEventListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeTrueUpEventList>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeTrueUpEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeTrueUpEventListQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeTrueUpEventList>>> = ({ signal }) => feeTrueUpEventList(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeTrueUpEventList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeTrueUpEventListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeTrueUpEventList>>>
export type FeeTrueUpEventListSuspenseQueryError = unknown

export const useFeeTrueUpEventListSuspense = <TData = Awaited<ReturnType<typeof feeTrueUpEventList>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeTrueUpEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeTrueUpEventListSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeTrueUpEventListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeTrueUpEventListQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => feeTrueUpEventList(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Runs a Fee True Up
 */
export const feeTrueUpEventCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FeeTrueUpEventReadDataList>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fee_true_up/`, method: 'POST'
    },
      options);
    }
  


export const getFeeTrueUpEventCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeTrueUpEventCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeTrueUpEventCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeTrueUpEventCreate>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  feeTrueUpEventCreate(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeTrueUpEventCreateMutationResult = NonNullable<Awaited<ReturnType<typeof feeTrueUpEventCreate>>>
    
    export type FeeTrueUpEventCreateMutationError = unknown

    export const useFeeTrueUpEventCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeTrueUpEventCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeTrueUpEventCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Finalizes a fund family event
 */
export const fundFamilyEventFinalize = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/finalize`, method: 'PATCH'
    },
      options);
    }
  


export const getFundFamilyEventFinalizeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventFinalize>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventFinalize>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyEventFinalize>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  fundFamilyEventFinalize(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyEventFinalizeMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventFinalize>>>
    
    export type FundFamilyEventFinalizeMutationError = unknown

    export const useFundFamilyEventFinalize = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventFinalize>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyEventFinalizeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get preferred return breakdown data
 */
export const waterfallPreferredReturnBreakdownTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnBreakdownTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/preferred-return-breakdown/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getWaterfallPreferredReturnBreakdownTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnBreakdownTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/preferred-return-breakdown/`, ...(params ? [params]: [])] as const;
    }

    
export const getWaterfallPreferredReturnBreakdownTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallPreferredReturnBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>> = ({ signal }) => waterfallPreferredReturnBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallPreferredReturnBreakdownTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>>
export type WaterfallPreferredReturnBreakdownTableDataRetrieveQueryError = unknown

export const useWaterfallPreferredReturnBreakdownTableDataRetrieve = <TData = Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallPreferredReturnBreakdownTableDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallPreferredReturnBreakdownTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallPreferredReturnBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>> = ({ signal }) => waterfallPreferredReturnBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallPreferredReturnBreakdownTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>>
export type WaterfallPreferredReturnBreakdownTableDataRetrieveSuspenseQueryError = unknown

export const useWaterfallPreferredReturnBreakdownTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallPreferredReturnBreakdownTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallPreferredReturnBreakdownTableDataRetrieveLoader = (queryParamsOrFn?: (WaterfallPreferredReturnBreakdownTableDataRetrieveParams | ((params: Params) => WaterfallPreferredReturnBreakdownTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string,fundEntityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallPreferredReturnBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId, queryParams),
              queryFn: () => waterfallPreferredReturnBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get preferred return summary data
 */
export const waterfallPreferredReturnSummaryDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnSummaryDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<PreferredReturnSummaryData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/preferred-return-summary/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getWaterfallPreferredReturnSummaryDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnSummaryDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/preferred-return-summary/`, ...(params ? [params]: [])] as const;
    }

    
export const getWaterfallPreferredReturnSummaryDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnSummaryDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallPreferredReturnSummaryDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>> = ({ signal }) => waterfallPreferredReturnSummaryDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallPreferredReturnSummaryDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>>
export type WaterfallPreferredReturnSummaryDataRetrieveQueryError = unknown

export const useWaterfallPreferredReturnSummaryDataRetrieve = <TData = Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnSummaryDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallPreferredReturnSummaryDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallPreferredReturnSummaryDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnSummaryDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallPreferredReturnSummaryDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>> = ({ signal }) => waterfallPreferredReturnSummaryDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallPreferredReturnSummaryDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>>
export type WaterfallPreferredReturnSummaryDataRetrieveSuspenseQueryError = unknown

export const useWaterfallPreferredReturnSummaryDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallPreferredReturnSummaryDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallPreferredReturnSummaryDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallPreferredReturnSummaryDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallPreferredReturnSummaryDataRetrieveLoader = (queryParamsOrFn?: (WaterfallPreferredReturnSummaryDataRetrieveParams | ((params: Params) => WaterfallPreferredReturnSummaryDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string,fundEntityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallPreferredReturnSummaryDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId, queryParams),
              queryFn: () => waterfallPreferredReturnSummaryDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get waterfall distribution for security ownership
 */
export const waterfallBreakdownRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallBreakdownRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<WaterfallDistributionData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getWaterfallBreakdownRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallBreakdownRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall`, ...(params ? [params]: [])] as const;
    }

    
export const getWaterfallBreakdownRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallBreakdownRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>> = ({ signal }) => waterfallBreakdownRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallBreakdownRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>>
export type WaterfallBreakdownRetrieveQueryError = unknown

export const useWaterfallBreakdownRetrieve = <TData = Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallBreakdownRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallBreakdownRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallBreakdownRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>> = ({ signal }) => waterfallBreakdownRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallBreakdownRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>>
export type WaterfallBreakdownRetrieveSuspenseQueryError = unknown

export const useWaterfallBreakdownRetrieveSuspense = <TData = Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallBreakdownRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallBreakdownRetrieveLoader = (queryParamsOrFn?: (WaterfallBreakdownRetrieveParams | ((params: Params) => WaterfallBreakdownRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string,fundEntityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallBreakdownRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId, queryParams),
              queryFn: () => waterfallBreakdownRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get investor level waterfall breakdown data
 */
export const waterfallInvestorLevelBreakdownTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallInvestorLevelBreakdownTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-investor-breakdown/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getWaterfallInvestorLevelBreakdownTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallInvestorLevelBreakdownTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-investor-breakdown/`, ...(params ? [params]: [])] as const;
    }

    
export const getWaterfallInvestorLevelBreakdownTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallInvestorLevelBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallInvestorLevelBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>> = ({ signal }) => waterfallInvestorLevelBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallInvestorLevelBreakdownTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>>
export type WaterfallInvestorLevelBreakdownTableDataRetrieveQueryError = unknown

export const useWaterfallInvestorLevelBreakdownTableDataRetrieve = <TData = Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallInvestorLevelBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallInvestorLevelBreakdownTableDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallInvestorLevelBreakdownTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallInvestorLevelBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallInvestorLevelBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>> = ({ signal }) => waterfallInvestorLevelBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallInvestorLevelBreakdownTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>>
export type WaterfallInvestorLevelBreakdownTableDataRetrieveSuspenseQueryError = unknown

export const useWaterfallInvestorLevelBreakdownTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
    params?: WaterfallInvestorLevelBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallInvestorLevelBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallInvestorLevelBreakdownTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallInvestorLevelBreakdownTableDataRetrieveLoader = (queryParamsOrFn?: (WaterfallInvestorLevelBreakdownTableDataRetrieveParams | ((params: Params) => WaterfallInvestorLevelBreakdownTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string,fundEntityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId && fundEntityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallInvestorLevelBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId, queryParams),
              queryFn: () => waterfallInvestorLevelBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Creates an instance of a waterfall run or updates the waterfall run if it already exists
 */
export const waterfallRunUpsert = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<WaterfallRunData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-run/`, method: 'POST'
    },
      options);
    }
  


export const getWaterfallRunUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallRunUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof waterfallRunUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof waterfallRunUpsert>>, {fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId} = props ?? {};

          return  waterfallRunUpsert(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WaterfallRunUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof waterfallRunUpsert>>>
    
    export type WaterfallRunUpsertMutationError = unknown

    export const useWaterfallRunUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallRunUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getWaterfallRunUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Creates a new waterfall run and runs it
 */
export const waterfallCreateAndRun = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-run/create-and-run/`, method: 'POST'
    },
      options);
    }
  


export const getWaterfallCreateAndRunMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallCreateAndRun>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof waterfallCreateAndRun>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof waterfallCreateAndRun>>, {fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId} = props ?? {};

          return  waterfallCreateAndRun(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WaterfallCreateAndRunMutationResult = NonNullable<Awaited<ReturnType<typeof waterfallCreateAndRun>>>
    
    export type WaterfallCreateAndRunMutationError = unknown

    export const useWaterfallCreateAndRun = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallCreateAndRun>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getWaterfallCreateAndRunMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Triggers a waterfall run for a specific waterfall
 */
export const runWaterfall = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    fundEntityId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/fund-entity/${fundEntityId}/waterfall-run/run/`, method: 'POST'
    },
      options);
    }
  


export const getRunWaterfallMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runWaterfall>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof runWaterfall>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runWaterfall>>, {fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId} = props ?? {};

          return  runWaterfall(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,fundEntityId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RunWaterfallMutationResult = NonNullable<Awaited<ReturnType<typeof runWaterfall>>>
    
    export type RunWaterfallMutationError = unknown

    export const useRunWaterfall = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runWaterfall>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;fundEntityId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getRunWaterfallMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets juniper square export file response
 */
export const investorPortalDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<Blob>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/investor-portal-exports/`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  

export const getInvestorPortalDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/investor-portal-exports/`] as const;
    }

    
export const getInvestorPortalDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investorPortalDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorPortalDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorPortalDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorPortalDataRetrieve>>> = ({ signal }) => investorPortalDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investorPortalDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorPortalDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investorPortalDataRetrieve>>>
export type InvestorPortalDataRetrieveQueryError = unknown

export const useInvestorPortalDataRetrieve = <TData = Awaited<ReturnType<typeof investorPortalDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investorPortalDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorPortalDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestorPortalDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investorPortalDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorPortalDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestorPortalDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investorPortalDataRetrieve>>> = ({ signal }) => investorPortalDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorPortalDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestorPortalDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investorPortalDataRetrieve>>>
export type InvestorPortalDataRetrieveSuspenseQueryError = unknown

export const useInvestorPortalDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof investorPortalDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investorPortalDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestorPortalDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestorPortalDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestorPortalDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId),
              queryFn: () => investorPortalDataRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create Waterfall Audit Excel Workbook and associated Document
 */
export const waterfallAuditExcelWorkbookCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: WaterfallAuditExcelWorkbookCreateParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<AuditDocuments>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-event/${fundFamilySubEventId}/waterfall-audit/`, method: 'POST',
        params
    },
      options);
    }
  


export const getWaterfallAuditExcelWorkbookCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallAuditExcelWorkbookCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;params?: WaterfallAuditExcelWorkbookCreateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof waterfallAuditExcelWorkbookCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;params?: WaterfallAuditExcelWorkbookCreateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof waterfallAuditExcelWorkbookCreate>>, {fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;params?: WaterfallAuditExcelWorkbookCreateParams}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params} = props ?? {};

          return  waterfallAuditExcelWorkbookCreate(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WaterfallAuditExcelWorkbookCreateMutationResult = NonNullable<Awaited<ReturnType<typeof waterfallAuditExcelWorkbookCreate>>>
    
    export type WaterfallAuditExcelWorkbookCreateMutationError = unknown

    export const useWaterfallAuditExcelWorkbookCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallAuditExcelWorkbookCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;params?: WaterfallAuditExcelWorkbookCreateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getWaterfallAuditExcelWorkbookCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Lists fund family sub events
 */
export const fundFamilySubEventList = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundFamilySubEventReadDataList>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-events`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFundFamilySubEventListQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventListParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-events`, ...(params ? [params]: [])] as const;
    }

    
export const getFundFamilySubEventListQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySubEventList>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySubEventListQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySubEventList>>> = ({ signal }) => fundFamilySubEventList(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventList>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySubEventListQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventList>>>
export type FundFamilySubEventListQueryError = unknown

export const useFundFamilySubEventList = <TData = Awaited<ReturnType<typeof fundFamilySubEventList>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySubEventListQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilySubEventListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySubEventList>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySubEventListQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySubEventList>>> = ({ signal }) => fundFamilySubEventList(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventList>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySubEventListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventList>>>
export type FundFamilySubEventListSuspenseQueryError = unknown

export const useFundFamilySubEventListSuspense = <TData = Awaited<ReturnType<typeof fundFamilySubEventList>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySubEventListSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilySubEventListLoader = (queryParamsOrFn?: (FundFamilySubEventListParams | ((params: Params) => FundFamilySubEventListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilySubEventListQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => fundFamilySubEventList(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Lists fund family sub events
 */
export const fundFamilySubEventFirstRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventFirstRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<NullableFundfmailySubEventData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-events/first`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFundFamilySubEventFirstRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventFirstRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/fund-family-sub-events/first`, ...(params ? [params]: [])] as const;
    }

    
export const getFundFamilySubEventFirstRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventFirstRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySubEventFirstRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>> = ({ signal }) => fundFamilySubEventFirstRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySubEventFirstRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>>
export type FundFamilySubEventFirstRetrieveQueryError = unknown

export const useFundFamilySubEventFirstRetrieve = <TData = Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventFirstRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySubEventFirstRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilySubEventFirstRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventFirstRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilySubEventFirstRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>> = ({ signal }) => fundFamilySubEventFirstRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilySubEventFirstRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>>
export type FundFamilySubEventFirstRetrieveSuspenseQueryError = unknown

export const useFundFamilySubEventFirstRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: FundFamilySubEventFirstRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilySubEventFirstRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilySubEventFirstRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilySubEventFirstRetrieveLoader = (queryParamsOrFn?: (FundFamilySubEventFirstRetrieveParams | ((params: Params) => FundFamilySubEventFirstRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilySubEventFirstRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => fundFamilySubEventFirstRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create ILPA Notice Excel Workbook and associated Document
 */
export const ilpaNoticeExcelWorkbookCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<DocumentReadData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/ilpa-notice-workbook/`, method: 'POST'
    },
      options);
    }
  


export const getIlpaNoticeExcelWorkbookCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ilpaNoticeExcelWorkbookCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof ilpaNoticeExcelWorkbookCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ilpaNoticeExcelWorkbookCreate>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  ilpaNoticeExcelWorkbookCreate(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IlpaNoticeExcelWorkbookCreateMutationResult = NonNullable<Awaited<ReturnType<typeof ilpaNoticeExcelWorkbookCreate>>>
    
    export type IlpaNoticeExcelWorkbookCreateMutationError = unknown

    export const useIlpaNoticeExcelWorkbookCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ilpaNoticeExcelWorkbookCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getIlpaNoticeExcelWorkbookCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets yardi export file response
 */
export const investmentManagerDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<Blob>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/investment-manager-exports/`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  

export const getInvestmentManagerDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/investment-manager-exports/`] as const;
    }

    
export const getInvestmentManagerDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investmentManagerDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentManagerDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentManagerDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentManagerDataRetrieve>>> = ({ signal }) => investmentManagerDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investmentManagerDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentManagerDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investmentManagerDataRetrieve>>>
export type InvestmentManagerDataRetrieveQueryError = unknown

export const useInvestmentManagerDataRetrieve = <TData = Awaited<ReturnType<typeof investmentManagerDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentManagerDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentManagerDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestmentManagerDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investmentManagerDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentManagerDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentManagerDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentManagerDataRetrieve>>> = ({ signal }) => investmentManagerDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentManagerDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentManagerDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investmentManagerDataRetrieve>>>
export type InvestmentManagerDataRetrieveSuspenseQueryError = unknown

export const useInvestmentManagerDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof investmentManagerDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentManagerDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentManagerDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestmentManagerDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestmentManagerDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => investmentManagerDataRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Lists the investment memos for a fund family event.
 */
export const investmentMemoList = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<DocumentReadDataList>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/investment-memo/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestmentMemoListQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/investment-memo/`] as const;
    }

    
export const getInvestmentMemoListQueryOptions = <TData = Awaited<ReturnType<typeof investmentMemoList>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentMemoList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentMemoListQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentMemoList>>> = ({ signal }) => investmentMemoList(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investmentMemoList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentMemoListQueryResult = NonNullable<Awaited<ReturnType<typeof investmentMemoList>>>
export type InvestmentMemoListQueryError = unknown

export const useInvestmentMemoList = <TData = Awaited<ReturnType<typeof investmentMemoList>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentMemoList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentMemoListQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestmentMemoListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investmentMemoList>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentMemoList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentMemoListQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentMemoList>>> = ({ signal }) => investmentMemoList(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentMemoList>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentMemoListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investmentMemoList>>>
export type InvestmentMemoListSuspenseQueryError = unknown

export const useInvestmentMemoListSuspense = <TData = Awaited<ReturnType<typeof investmentMemoList>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentMemoList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentMemoListSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestmentMemoListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestmentMemoListQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => investmentMemoList(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upserts investment memo.
 */
export const upsertInvestmentMemo = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    noticeDocumentCreateDataRequest: NoticeDocumentCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<NoticeDocumentReadData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/investment-memo/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: noticeDocumentCreateDataRequest
    },
      options);
    }
  


export const getUpsertInvestmentMemoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertInvestmentMemo>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: NoticeDocumentCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertInvestmentMemo>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: NoticeDocumentCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertInvestmentMemo>>, {fundFamilyId: string;fundFamilyEventId: string;data: NoticeDocumentCreateDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  upsertInvestmentMemo(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertInvestmentMemoMutationResult = NonNullable<Awaited<ReturnType<typeof upsertInvestmentMemo>>>
    export type UpsertInvestmentMemoMutationBody = NoticeDocumentCreateDataRequest
    export type UpsertInvestmentMemoMutationError = unknown

    export const useUpsertInvestmentMemo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertInvestmentMemo>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: NoticeDocumentCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getUpsertInvestmentMemoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes investment memo.
 */
export const investmentMemoDestroy = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/investment-memo/`, method: 'DELETE'
    },
      options);
    }
  


export const getInvestmentMemoDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentMemoDestroy>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof investmentMemoDestroy>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof investmentMemoDestroy>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  investmentMemoDestroy(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvestmentMemoDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof investmentMemoDestroy>>>
    
    export type InvestmentMemoDestroyMutationError = unknown

    export const useInvestmentMemoDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof investmentMemoDestroy>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInvestmentMemoDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Creates notices
 */
export const noticesCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/notice/`, method: 'POST'
    },
      options);
    }
  


export const getNoticesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noticesCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof noticesCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof noticesCreate>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  noticesCreate(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NoticesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof noticesCreate>>>
    
    export type NoticesCreateMutationError = unknown

    export const useNoticesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noticesCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getNoticesCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes notices.
 */
export const noticeDestroy = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/notice-delete/`, method: 'DELETE'
    },
      options);
    }
  


export const getNoticeDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noticeDestroy>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof noticeDestroy>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof noticeDestroy>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  noticeDestroy(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NoticeDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof noticeDestroy>>>
    
    export type NoticeDestroyMutationError = unknown

    export const useNoticeDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noticeDestroy>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getNoticeDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets the status for notice document generation.
 */
export const noticeDocumentGenerationStatusRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<NoticeDocumentGenerationStatusData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/notice-documents-status/`, method: 'GET', signal
    },
      options);
    }
  

export const getNoticeDocumentGenerationStatusRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/notice-documents-status/`] as const;
    }

    
export const getNoticeDocumentGenerationStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNoticeDocumentGenerationStatusRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>> = ({ signal }) => noticeDocumentGenerationStatusRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type NoticeDocumentGenerationStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>>
export type NoticeDocumentGenerationStatusRetrieveQueryError = unknown

export const useNoticeDocumentGenerationStatusRetrieve = <TData = Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNoticeDocumentGenerationStatusRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNoticeDocumentGenerationStatusRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNoticeDocumentGenerationStatusRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>> = ({ signal }) => noticeDocumentGenerationStatusRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type NoticeDocumentGenerationStatusRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>>
export type NoticeDocumentGenerationStatusRetrieveSuspenseQueryError = unknown

export const useNoticeDocumentGenerationStatusRetrieveSuspense = <TData = Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeDocumentGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNoticeDocumentGenerationStatusRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getNoticeDocumentGenerationStatusRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getNoticeDocumentGenerationStatusRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => noticeDocumentGenerationStatusRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets the table data for notice documents tied to a fund family event.
 */
export const noticeDocumentTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/notice-documents-table/`, method: 'GET', signal
    },
      options);
    }
  

export const getNoticeDocumentTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/notice-documents-table/`] as const;
    }

    
export const getNoticeDocumentTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNoticeDocumentTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>> = ({ signal }) => noticeDocumentTableDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type NoticeDocumentTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>>
export type NoticeDocumentTableDataRetrieveQueryError = unknown

export const useNoticeDocumentTableDataRetrieve = <TData = Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNoticeDocumentTableDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNoticeDocumentTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNoticeDocumentTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>> = ({ signal }) => noticeDocumentTableDataRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type NoticeDocumentTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>>
export type NoticeDocumentTableDataRetrieveSuspenseQueryError = unknown

export const useNoticeDocumentTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeDocumentTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNoticeDocumentTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getNoticeDocumentTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getNoticeDocumentTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => noticeDocumentTableDataRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Downloads all notices for a fund family event id
 */
export const noticeDocumentDownloadCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<Blob>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/notice-download/`, method: 'POST',
        responseType: 'blob'
    },
      options);
    }
  


export const getNoticeDocumentDownloadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noticeDocumentDownloadCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof noticeDocumentDownloadCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof noticeDocumentDownloadCreate>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  noticeDocumentDownloadCreate(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NoticeDocumentDownloadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof noticeDocumentDownloadCreate>>>
    
    export type NoticeDocumentDownloadCreateMutationError = unknown

    export const useNoticeDocumentDownloadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noticeDocumentDownloadCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getNoticeDocumentDownloadCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets fee offsets posted per quarter.
 */
export const listFeeChargeEventsWithOutstandingFeeOffsetExpenses = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeChargeEventsWithOutstandingOffsetExpenseAmountsByExpenseTransactionCodes>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/outstanding-offsets-to-call`, method: 'GET', signal
    },
      options);
    }
  

export const getListFeeChargeEventsWithOutstandingFeeOffsetExpensesQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/outstanding-offsets-to-call`] as const;
    }

    
export const getListFeeChargeEventsWithOutstandingFeeOffsetExpensesQueryOptions = <TData = Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFeeChargeEventsWithOutstandingFeeOffsetExpensesQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>> = ({ signal }) => listFeeChargeEventsWithOutstandingFeeOffsetExpenses(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFeeChargeEventsWithOutstandingFeeOffsetExpensesQueryResult = NonNullable<Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>>
export type ListFeeChargeEventsWithOutstandingFeeOffsetExpensesQueryError = unknown

export const useListFeeChargeEventsWithOutstandingFeeOffsetExpenses = <TData = Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListFeeChargeEventsWithOutstandingFeeOffsetExpensesQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getListFeeChargeEventsWithOutstandingFeeOffsetExpensesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFeeChargeEventsWithOutstandingFeeOffsetExpensesQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>> = ({ signal }) => listFeeChargeEventsWithOutstandingFeeOffsetExpenses(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFeeChargeEventsWithOutstandingFeeOffsetExpensesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>>
export type ListFeeChargeEventsWithOutstandingFeeOffsetExpensesSuspenseQueryError = unknown

export const useListFeeChargeEventsWithOutstandingFeeOffsetExpensesSuspense = <TData = Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listFeeChargeEventsWithOutstandingFeeOffsetExpenses>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListFeeChargeEventsWithOutstandingFeeOffsetExpensesSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getListFeeChargeEventsWithOutstandingFeeOffsetExpensesLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getListFeeChargeEventsWithOutstandingFeeOffsetExpensesQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => listFeeChargeEventsWithOutstandingFeeOffsetExpenses(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Updates a fund family event from pending to complete
 */
export const fundFamilyEventPendingToCompleteUpdate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/pending-to-complete`, method: 'PATCH'
    },
      options);
    }
  


export const getFundFamilyEventPendingToCompleteUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventPendingToCompleteUpdate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventPendingToCompleteUpdate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyEventPendingToCompleteUpdate>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  fundFamilyEventPendingToCompleteUpdate(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyEventPendingToCompleteUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventPendingToCompleteUpdate>>>
    
    export type FundFamilyEventPendingToCompleteUpdateMutationError = unknown

    export const useFundFamilyEventPendingToCompleteUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventPendingToCompleteUpdate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyEventPendingToCompleteUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Rebalance portfolio transactions
 */
export const portfolioTransactionRebalanceUpsert = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/rebalance-portfolio-transactions`, method: 'POST'
    },
      options);
    }
  


export const getPortfolioTransactionRebalanceUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioTransactionRebalanceUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof portfolioTransactionRebalanceUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof portfolioTransactionRebalanceUpsert>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  portfolioTransactionRebalanceUpsert(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PortfolioTransactionRebalanceUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof portfolioTransactionRebalanceUpsert>>>
    
    export type PortfolioTransactionRebalanceUpsertMutationError = unknown

    export const usePortfolioTransactionRebalanceUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portfolioTransactionRebalanceUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getPortfolioTransactionRebalanceUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Refreshes a fund family event
 */
export const fundFamilyEventRefresh = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventRefreshData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/refresh`, method: 'POST'
    },
      options);
    }
  


export const getFundFamilyEventRefreshMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventRefresh>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventRefresh>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyEventRefresh>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  fundFamilyEventRefresh(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyEventRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyEventRefresh>>>
    
    export type FundFamilyEventRefreshMutationError = unknown

    export const useFundFamilyEventRefresh = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyEventRefresh>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyEventRefreshMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Processes a fund family sub event for a fund family event
 */
export const fundFamilySubEventProcess = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    genericFundFamilySubEventCreateDataRequest: GenericFundFamilySubEventCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/sub-event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: genericFundFamilySubEventCreateDataRequest
    },
      options);
    }
  


export const getFundFamilySubEventProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilySubEventProcess>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: GenericFundFamilySubEventCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilySubEventProcess>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: GenericFundFamilySubEventCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilySubEventProcess>>, {fundFamilyId: string;fundFamilyEventId: string;data: GenericFundFamilySubEventCreateDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  fundFamilySubEventProcess(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilySubEventProcessMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilySubEventProcess>>>
    export type FundFamilySubEventProcessMutationBody = GenericFundFamilySubEventCreateDataRequest
    export type FundFamilySubEventProcessMutationError = unknown

    export const useFundFamilySubEventProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilySubEventProcess>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: GenericFundFamilySubEventCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilySubEventProcessMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets transaction map.
 */
export const transactionMapRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params: TransactionMapRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TransactionMapAPIResponse>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/transaction-map`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getTransactionMapRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params: TransactionMapRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/transaction-map`, ...(params ? [params]: [])] as const;
    }

    
export const getTransactionMapRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof transactionMapRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params: TransactionMapRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionMapRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionMapRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionMapRetrieve>>> = ({ signal }) => transactionMapRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transactionMapRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionMapRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof transactionMapRetrieve>>>
export type TransactionMapRetrieveQueryError = unknown

export const useTransactionMapRetrieve = <TData = Awaited<ReturnType<typeof transactionMapRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params: TransactionMapRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transactionMapRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionMapRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTransactionMapRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof transactionMapRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params: TransactionMapRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionMapRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransactionMapRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof transactionMapRetrieve>>> = ({ signal }) => transactionMapRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionMapRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type TransactionMapRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof transactionMapRetrieve>>>
export type TransactionMapRetrieveSuspenseQueryError = unknown

export const useTransactionMapRetrieveSuspense = <TData = Awaited<ReturnType<typeof transactionMapRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params: TransactionMapRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof transactionMapRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTransactionMapRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getTransactionMapRetrieveLoader = (queryParamsOrFn: (TransactionMapRetrieveParams | ((params: Params) => TransactionMapRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getTransactionMapRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => transactionMapRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Lists the waterfall runs for a specific fund family event
 */
export const waterfallRunList = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: WaterfallRunListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<WaterfallRunDataList>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-list/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getWaterfallRunListQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: WaterfallRunListParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-list/`, ...(params ? [params]: [])] as const;
    }

    
export const getWaterfallRunListQueryOptions = <TData = Awaited<ReturnType<typeof waterfallRunList>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: WaterfallRunListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallRunList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallRunListQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallRunList>>> = ({ signal }) => waterfallRunList(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallRunList>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallRunListQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallRunList>>>
export type WaterfallRunListQueryError = unknown

export const useWaterfallRunList = <TData = Awaited<ReturnType<typeof waterfallRunList>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: WaterfallRunListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallRunList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallRunListQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallRunListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallRunList>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: WaterfallRunListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallRunList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallRunListQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallRunList>>> = ({ signal }) => waterfallRunList(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallRunList>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallRunListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallRunList>>>
export type WaterfallRunListSuspenseQueryError = unknown

export const useWaterfallRunListSuspense = <TData = Awaited<ReturnType<typeof waterfallRunList>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: WaterfallRunListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallRunList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallRunListSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallRunListLoader = (queryParamsOrFn?: (WaterfallRunListParams | ((params: Params) => WaterfallRunListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallRunListQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => waterfallRunList(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get accelerated paydown investment workflow table
 */
export const acceleratedPaydownInvestmentTableRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: AcceleratedPaydownInvestmentTableRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<PaydownTableResponse>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/${fundFamilySubEventId}/accelerated-paydown-investment/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAcceleratedPaydownInvestmentTableRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: AcceleratedPaydownInvestmentTableRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/${fundFamilySubEventId}/accelerated-paydown-investment/`, ...(params ? [params]: [])] as const;
    }

    
export const getAcceleratedPaydownInvestmentTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: AcceleratedPaydownInvestmentTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcceleratedPaydownInvestmentTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>> = ({ signal }) => acceleratedPaydownInvestmentTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AcceleratedPaydownInvestmentTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>>
export type AcceleratedPaydownInvestmentTableRetrieveQueryError = unknown

export const useAcceleratedPaydownInvestmentTableRetrieve = <TData = Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: AcceleratedPaydownInvestmentTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAcceleratedPaydownInvestmentTableRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAcceleratedPaydownInvestmentTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: AcceleratedPaydownInvestmentTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcceleratedPaydownInvestmentTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>> = ({ signal }) => acceleratedPaydownInvestmentTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AcceleratedPaydownInvestmentTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>>
export type AcceleratedPaydownInvestmentTableRetrieveSuspenseQueryError = unknown

export const useAcceleratedPaydownInvestmentTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: AcceleratedPaydownInvestmentTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof acceleratedPaydownInvestmentTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAcceleratedPaydownInvestmentTableRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAcceleratedPaydownInvestmentTableRetrieveLoader = (queryParamsOrFn?: (AcceleratedPaydownInvestmentTableRetrieveParams | ((params: Params) => AcceleratedPaydownInvestmentTableRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAcceleratedPaydownInvestmentTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, queryParams),
              queryFn: () => acceleratedPaydownInvestmentTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get fund expense allocations summary table
 */
export const fundExpenseAllocationsTableRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundExpenseAllocationTableAndStats>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/${fundFamilySubEventId}/fund-expense-allocations/`, method: 'GET', signal
    },
      options);
    }
  

export const getFundExpenseAllocationsTableRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/${fundFamilySubEventId}/fund-expense-allocations/`] as const;
    }

    
export const getFundExpenseAllocationsTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundExpenseAllocationsTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>> = ({ signal }) => fundExpenseAllocationsTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundExpenseAllocationsTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>>
export type FundExpenseAllocationsTableRetrieveQueryError = unknown

export const useFundExpenseAllocationsTableRetrieve = <TData = Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundExpenseAllocationsTableRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundExpenseAllocationsTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundExpenseAllocationsTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>> = ({ signal }) => fundExpenseAllocationsTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundExpenseAllocationsTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>>
export type FundExpenseAllocationsTableRetrieveSuspenseQueryError = unknown

export const useFundExpenseAllocationsTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundExpenseAllocationsTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundExpenseAllocationsTableRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundExpenseAllocationsTableRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundExpenseAllocationsTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId),
              queryFn: () => fundExpenseAllocationsTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get investment classifications summary table
 */
export const investmentClassificationsSummaryTableRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/${fundFamilySubEventId}/investment-classifications-summary/`, method: 'GET', signal
    },
      options);
    }
  

export const getInvestmentClassificationsSummaryTableRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/${fundFamilySubEventId}/investment-classifications-summary/`] as const;
    }

    
export const getInvestmentClassificationsSummaryTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentClassificationsSummaryTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>> = ({ signal }) => investmentClassificationsSummaryTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentClassificationsSummaryTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>>
export type InvestmentClassificationsSummaryTableRetrieveQueryError = unknown

export const useInvestmentClassificationsSummaryTableRetrieve = <TData = Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentClassificationsSummaryTableRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInvestmentClassificationsSummaryTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvestmentClassificationsSummaryTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>> = ({ signal }) => investmentClassificationsSummaryTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InvestmentClassificationsSummaryTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>>
export type InvestmentClassificationsSummaryTableRetrieveSuspenseQueryError = unknown

export const useInvestmentClassificationsSummaryTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof investmentClassificationsSummaryTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInvestmentClassificationsSummaryTableRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInvestmentClassificationsSummaryTableRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInvestmentClassificationsSummaryTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId),
              queryFn: () => investmentClassificationsSummaryTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get required paydown investment workflow table
 */
export const requiredPaydownInvestmentTableRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: RequiredPaydownInvestmentTableRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<PaydownTableResponse>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/${fundFamilySubEventId}/required-paydown-investment/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getRequiredPaydownInvestmentTableRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: RequiredPaydownInvestmentTableRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/${fundFamilySubEventId}/required-paydown-investment/`, ...(params ? [params]: [])] as const;
    }

    
export const getRequiredPaydownInvestmentTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: RequiredPaydownInvestmentTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequiredPaydownInvestmentTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>> = ({ signal }) => requiredPaydownInvestmentTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type RequiredPaydownInvestmentTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>>
export type RequiredPaydownInvestmentTableRetrieveQueryError = unknown

export const useRequiredPaydownInvestmentTableRetrieve = <TData = Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: RequiredPaydownInvestmentTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getRequiredPaydownInvestmentTableRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getRequiredPaydownInvestmentTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: RequiredPaydownInvestmentTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequiredPaydownInvestmentTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>> = ({ signal }) => requiredPaydownInvestmentTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type RequiredPaydownInvestmentTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>>
export type RequiredPaydownInvestmentTableRetrieveSuspenseQueryError = unknown

export const useRequiredPaydownInvestmentTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: RequiredPaydownInvestmentTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof requiredPaydownInvestmentTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getRequiredPaydownInvestmentTableRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getRequiredPaydownInvestmentTableRetrieveLoader = (queryParamsOrFn?: (RequiredPaydownInvestmentTableRetrieveParams | ((params: Params) => RequiredPaydownInvestmentTableRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getRequiredPaydownInvestmentTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, queryParams),
              queryFn: () => requiredPaydownInvestmentTableRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets the waterfall tiers for the fund family
 */
export const waterfallTiersRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: WaterfallTiersRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<WaterfallTiers>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/${fundFamilySubEventId}/tiers/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getWaterfallTiersRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: WaterfallTiersRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/${fundFamilySubEventId}/tiers/`, ...(params ? [params]: [])] as const;
    }

    
export const getWaterfallTiersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof waterfallTiersRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: WaterfallTiersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallTiersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallTiersRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallTiersRetrieve>>> = ({ signal }) => waterfallTiersRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof waterfallTiersRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallTiersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallTiersRetrieve>>>
export type WaterfallTiersRetrieveQueryError = unknown

export const useWaterfallTiersRetrieve = <TData = Awaited<ReturnType<typeof waterfallTiersRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: WaterfallTiersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof waterfallTiersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallTiersRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWaterfallTiersRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof waterfallTiersRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: WaterfallTiersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallTiersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWaterfallTiersRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof waterfallTiersRetrieve>>> = ({ signal }) => waterfallTiersRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId && fundFamilySubEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallTiersRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type WaterfallTiersRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof waterfallTiersRetrieve>>>
export type WaterfallTiersRetrieveSuspenseQueryError = unknown

export const useWaterfallTiersRetrieveSuspense = <TData = Awaited<ReturnType<typeof waterfallTiersRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    params?: WaterfallTiersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof waterfallTiersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWaterfallTiersRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getWaterfallTiersRetrieveLoader = (queryParamsOrFn?: (WaterfallTiersRetrieveParams | ((params: Params) => WaterfallTiersRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string,fundFamilySubEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId,fundFamilySubEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId && fundFamilySubEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getWaterfallTiersRetrieveQueryKey(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, queryParams),
              queryFn: () => waterfallTiersRetrieve(fundFamilyId,fundFamilyEventId,fundFamilySubEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Runs the hybrid waterfall (after it's already created.)
 */
export const runHybridWaterfall = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    fundFamilySubEventId: string,
    hybridWaterfallRunAdditionalDataRequest: HybridWaterfallRunAdditionalDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<WaterfallRunData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/run/${fundFamilySubEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hybridWaterfallRunAdditionalDataRequest
    },
      options);
    }
  


export const getRunHybridWaterfallMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runHybridWaterfall>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;data: HybridWaterfallRunAdditionalDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof runHybridWaterfall>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;data: HybridWaterfallRunAdditionalDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runHybridWaterfall>>, {fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;data: HybridWaterfallRunAdditionalDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,fundFamilySubEventId,data} = props ?? {};

          return  runHybridWaterfall(fundFamilyId,fundFamilyEventId,fundFamilySubEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RunHybridWaterfallMutationResult = NonNullable<Awaited<ReturnType<typeof runHybridWaterfall>>>
    export type RunHybridWaterfallMutationBody = HybridWaterfallRunAdditionalDataRequest
    export type RunHybridWaterfallMutationError = unknown

    export const useRunHybridWaterfall = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runHybridWaterfall>>, TError,{fundFamilyId: string;fundFamilyEventId: string;fundFamilySubEventId: string;data: HybridWaterfallRunAdditionalDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getRunHybridWaterfallMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Creates the hybrid waterfall runs
 */
export const hybridWaterfallRunUpsert = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    hybridWaterfallRunUpsertDataRequest: HybridWaterfallRunUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilySubEventReadData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/hybrid/upsert`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hybridWaterfallRunUpsertDataRequest
    },
      options);
    }
  


export const getHybridWaterfallRunUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hybridWaterfallRunUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: HybridWaterfallRunUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof hybridWaterfallRunUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: HybridWaterfallRunUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hybridWaterfallRunUpsert>>, {fundFamilyId: string;fundFamilyEventId: string;data: HybridWaterfallRunUpsertDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  hybridWaterfallRunUpsert(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HybridWaterfallRunUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof hybridWaterfallRunUpsert>>>
    export type HybridWaterfallRunUpsertMutationBody = HybridWaterfallRunUpsertDataRequest
    export type HybridWaterfallRunUpsertMutationError = unknown

    export const useHybridWaterfallRunUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hybridWaterfallRunUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: HybridWaterfallRunUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getHybridWaterfallRunUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Creates a new waterfall run and runs it
 */
export const newWaterfallForEventUpsertAndRun = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall-run/upsert-and-run/`, method: 'POST'
    },
      options);
    }
  


export const getNewWaterfallForEventUpsertAndRunMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof newWaterfallForEventUpsertAndRun>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof newWaterfallForEventUpsertAndRun>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof newWaterfallForEventUpsertAndRun>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  newWaterfallForEventUpsertAndRun(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NewWaterfallForEventUpsertAndRunMutationResult = NonNullable<Awaited<ReturnType<typeof newWaterfallForEventUpsertAndRun>>>
    
    export type NewWaterfallForEventUpsertAndRunMutationError = unknown

    export const useNewWaterfallForEventUpsertAndRun = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof newWaterfallForEventUpsertAndRun>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getNewWaterfallForEventUpsertAndRunMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Creates the waterfall subevent
 */
export const waterfallSubEventCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilySubEventReadData>(
      {url: `/fund-family/${fundFamilyId}/fund-family-event/${fundFamilyEventId}/waterfall/subevent`, method: 'POST'
    },
      options);
    }
  


export const getWaterfallSubEventCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallSubEventCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof waterfallSubEventCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof waterfallSubEventCreate>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  waterfallSubEventCreate(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WaterfallSubEventCreateMutationResult = NonNullable<Awaited<ReturnType<typeof waterfallSubEventCreate>>>
    
    export type WaterfallSubEventCreateMutationError = unknown

    export const useWaterfallSubEventCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waterfallSubEventCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getWaterfallSubEventCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    